import config from '@/config'
import { Route } from '@/contracts/core/api/entity/Route'

/** Маршруты модуля auth: работать ли без сервера, решает настройка модуля в src/config.ts */
export abstract class AuthRoute<P, T> extends Route<P, T> {
  isOffline(): boolean {
    return config.systemModules.auth.offline === 'true'
  }
}
